<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('subprogram.mainProgram') }} <span class="text-danger">*</span>
        </label>
        <ts-search-select :disabled="editing" v-model.number="model.acp_id"
          :options="mainProgramOptions"></ts-search-select>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('acp_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('subprogram.nameKH') }}</label>
        <input ref="acps_name_native" v-model="model.acps_name_native" type="text" class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('acps_name_native') }" :placeholder="$t('subprogram.enternameKH')" />
        <div class="invalid-feedback" v-if="errors.has('acps_name_native')">
          {{ errors.first('acps_name_native') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('subprogram.nameEN') }} <span class="text-danger">*</span>
        </label>
        <input v-model="model.acps_name_foreign" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('acps_name_foreign') }" :placeholder="$t('subprogram.enternameEN')" />
        <div class="invalid-feedback" v-if="errors.has('acps_name_foreign')">
          {{ errors.first('acps_name_foreign') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('subprogram.abbreviation') }}
        </label>
        <input v-model="model.acps_abbr" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('acps_abbr') }" :placeholder="$t('subprogram.enterAbbreviation')" />
        <div class="invalid-feedback" v-if="errors.has('acps_abbr')">
          {{ errors.first('acps_abbr') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('subprogram.numberofTermPerYear') }}
          <span class="text-danger">*</span>
        </label>
        <select class="form-control" v-model.number="model.number_of_term_per_ac_year"
          :class="{ 'is-invalid': errors.has('number_of_term_per_ac_year') }">
          <option value="" disabled selected style="display: none;">
            {{ $t('select') }}</option>
          <option v-for="number_of_term_per_ac_year in 4" :key="number_of_term_per_ac_year"
            :value="number_of_term_per_ac_year">{{ number_of_term_per_ac_year }}</option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('number_of_term_per_ac_year')">
          {{ errors.first('number_of_term_per_ac_year') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('subprogram.numberofTermPerGrade') }}
          <span class="text-danger">*</span>
        </label>
        <select class="form-control" v-model.number="model.number_of_term_per_grade"
          :class="{ 'is-invalid': errors.has('number_of_term_per_grade') }">
          <option value="" disabled selected style="display: none;">
            {{ $t('select') }}</option>
          <option v-for="number_of_term_per_grade in 4" :key="number_of_term_per_grade" :value="number_of_term_per_grade">
            {{ number_of_term_per_grade }}</option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('number_of_term_per_grade')">
          {{ errors.first('number_of_term_per_grade') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('subprogram.cardTemplate') }}
        </label>
        <select class="form-control" v-model="model.card_template_id"
          :class="{ 'is-invalid': errors.has('card_template_id') }">
          <option value="" disabled selected style="display: none;">
            --Select--</option>
          <option v-for="(c, index) in cardTemplates" :key="index" :value="c.card_template_id">
            {{ c.card_template_name }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('card_template_id')">
          {{ errors.first('card_template_id') }}
        </div>
      </div>
      <div class="form-group">
        <ts-checkbox v-model="model.is_exclude_from_payment_alert">{{
          $t('subprogram.excludeFromStudentUnpaid')
        }}</ts-checkbox>
      </div>
      <div class="form-group">
        <ts-checkbox v-model="model.calculate_average_score">{{
          $t('subprogram.calculateAverageScore')
        }}</ts-checkbox>
      </div>
      <div class="form-group" v-if="model.calculate_average_score">
        <label class="control-label">
          {{ $t('subprogram.averageScoreOn') }}
          <span class="text-danger">*</span>
        </label>
        <select class="form-control" v-model="model.average_score_on"
          :class="{ 'is-invalid': errors.has('average_score_on') }">
          <option value="" disabled selected style="display: none;">
            {{ $t('select') }}</option>
          <option v-for="(average_score, index) in average_scores" :key="index" :value="average_score.value">
            {{ average_score.name }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('average_score_on')">
          {{ errors.first('average_score_on') }}
        </div>
      </div>
      <div class="form-group">
        <scoring-cycle-list v-model="model"></scoring-cycle-list>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="update"
          v-if="editing == true">
          {{ $t('update') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import scoringCycleList from './components/scoring-cycle-list.vue'

export default {
  name: 'sub-program-create-form',
  props: ['edit'],
  components: { scoringCycleList },
  data() {
    return {
      model: {
        acp_id: '',
        acps_id: '',
        acps_name_native: '',
        acps_name_foreign: '',
        acps_abbr: '',
        number_of_term_per_ac_year: '',
        number_of_term_per_grade: '',
        is_exclude_from_payment_alert: false,
        calculate_average_score: false,
        average_score_on: '',
        card_template_id: '',
        scoring_cycle_list: []
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      average_scores: [
        {
          value: 1,
          name: 'Subject/Component'
        },
        {
          value: 2,
          name: 'Sub-Component'
        }
      ]
    }
  },
  mounted() {
    this.$refs.acps_name_native.focus()
  },
  created() {
    this.setEdit()
  },
  computed: {
    mainProgramOptions() {
      return this.$store.state.subProgram.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    cardTemplates() {
      return this.$store.state.subProgram.cardTemplates
    }
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'sub-program' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'subProgram/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.acps_name_native.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'subProgram/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'sub-program' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.acps_name_native.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      let {
        acp_id,
        acps_id,
        acps_name_native,
        acps_name_foreign,
        acps_abbr,
        number_of_term_per_ac_year,
        number_of_term_per_grade,
        is_exclude_from_payment_alert,
        calculate_average_score,
        average_score_on,
        card_template_id
      } = this.edit

      this.model.acp_id = acp_id
      this.model.acps_id = acps_id
      this.model.acps_name_native = acps_name_native
      this.model.acps_name_foreign = acps_name_foreign
      this.model.acps_abbr = acps_abbr
      this.model.number_of_term_per_ac_year = number_of_term_per_ac_year
      this.model.number_of_term_per_grade = number_of_term_per_grade
      this.model.is_exclude_from_payment_alert = is_exclude_from_payment_alert
      this.model.calculate_average_score = calculate_average_score
      this.model.average_score_on = average_score_on
      this.model.card_template_id = card_template_id

      this.edit.scoring_cyles.forEach(el => {
        this.model.scoring_cycle_list = Object.assign({}, this.model.scoring_cycle_list, {
          [el.scoring_cycle_id]: {
            display_in_scoring: el.display_in_scoring,
            scoring_cycle_id: parseInt(el.scoring_cycle_id)
          }
        })
      })

      this.editing = true
    },

    clearForm() {
      this.model.acp_id = ''
      this.model.acps_name_native = ''
      this.model.acps_name_foreign = ''
      this.model.acps_abbr = ''
      this.model.number_of_term_per_ac_year = ''
      this.model.number_of_term_per_grade = ''
      this.model.is_exclude_from_payment_alert = false
      this.model.calculate_average_score = false
      this.model.average_score_on = ''
      this.model.card_template_id = ''
      this.model.scoring_cycle_list = []
    }
  },
  watch: {
    'model.calculate_average_score': function (value) {
      if (value == false) {
        this.model.average_score_on = ''
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
